import '@/assets/styles/index.scss';
import 'vue-select/src/scss/vue-select.scss';
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
